import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Reveal from "@/components/base/Reveal";
import { artisans } from "@/mocks/artisans";

export default function ArtisansPage() {
  return (
    <main className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />

      {/* About the shop */}
      <section className="pt-28 md:pt-32 pb-12 md:pb-16 px-4 md:px-10 lg:px-14">
        <Reveal from="up" className="max-w-2xl">
          <h1 className="font-heading text-3xl md:text-4xl text-foreground-950 leading-tight">
            Artisans
          </h1>

          <div className="mt-6 space-y-5 text-sm md:text-base text-foreground-800 leading-relaxed">
            <p>
              Hearth &amp; Heirloom is a small shop of handmade goods made by
              moms across the American Midwest. Every piece is made slow, in
              small batches, from a home studio &mdash; never a factory.
            </p>
            <p>
              Orders ship within 2&ndash;3 days, wrapped in recycled muslin and
              tied with garden twine. Free U.S. shipping over $95. Questions?
              Write to{" "}
              <a
                href="mailto:hello@hearth.shop"
                className="text-foreground-950 underline hover:text-primary-700 cursor-pointer"
              >
                hello@hearth.shop
              </a>
              .
            </p>
          </div>
        </Reveal>
      </section>

      {/* The makers */}
      <section className="pb-20 md:pb-28 px-4 md:px-10 lg:px-14">
        <Reveal from="up">
          <h2 className="font-heading text-xl md:text-2xl text-foreground-950">
            Meet the makers
          </h2>
        </Reveal>

        <ul className="mt-8 md:mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
          {artisans.map((a, i) => (
            <Reveal as="li" key={a.id} from="up" delay={i * 100}>
              <div className="flex flex-col group">
                <div className="w-full aspect-[3/4] overflow-hidden bg-background-100 rounded-lg">
                  <img
                    src={a.portrait}
                    alt={a.name}
                    className="w-full h-full object-cover object-top transition-transform duration-[1400ms] ease-out group-hover:scale-[1.05]"
                  />
                </div>
                <div className="mt-4">
                  <h3 className="font-heading text-lg text-foreground-950">{a.name}</h3>
                  <p className="mt-1 text-sm text-foreground-700">{a.craft}</p>
                  <p className="mt-0.5 text-xs text-foreground-600">{a.location}</p>
                  <p className="mt-3 text-sm text-foreground-800 leading-relaxed">
                    &ldquo;{a.quote}&rdquo;
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </ul>

        <Reveal from="up" className="mt-12 md:mt-16">
          <Link
            to="/#collections"
            className="inline-flex items-center gap-2 px-5 h-10 rounded-full bg-foreground-950 text-background-50 text-sm font-medium hover:bg-foreground-900 cursor-pointer whitespace-nowrap group"
          >
            Shop their work
            <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1"></i>
          </Link>
        </Reveal>
      </section>

      <Footer />
    </main>
  );
}